module.exports = __webpack_public_path__ + "img/Disney_Carno.5d08d08e.webp";